import { useState } from 'react'
import axios from '@fs/zion-axios'
import { useUser } from '@fs/zion-user'
import useErrorReporter from './useErrorReporter'
import useFetchData from './useFetchData'

const fetchHiddenAncestors = async (cisId) => {
  if (!cisId) {
    return []
  }
  const { data: hiddenPersonIds = [] } = await axios.get(`/service/home/pie/users/${cisId}/ignored/persons`, {
    // cache-control required for cache busting. Value copied from current angular version.
    headers: { 'cache-control': 'no-cache, no-store, must-revalidate' },
  })
  if (!hiddenPersonIds.length) {
    return []
  }
  return hiddenPersonIds.map((personId) => {
    return {
      personId,
    }
  })
}

const unhideAncestor = async (cisId, personId) =>
  axios.delete(`/service/home/pie/users/${cisId}/ignored/persons/${personId}`)
const unhideAncestors = (cisId, personIds) => Promise.all(personIds.map((personId) => unhideAncestor(cisId, personId)))

export default function useHiddenAncestors() {
  const reportError = useErrorReporter()
  const { cisId } = useUser()
  const { data: remoteHiddenAncestors, loading: hiddenAncestorsLoading } = useFetchData(fetchHiddenAncestors, {
    initialData: [],
    requestFnArg: cisId,
  })
  const [localHiddenAncestors, setLocalHiddenAncestors] = useState(null)
  const hiddenAncestors = localHiddenAncestors || remoteHiddenAncestors

  const handleUnhideAncestors = (personIds = []) => {
    const newHiddenAncestors = hiddenAncestors.filter((x) => !personIds.some((personId) => x.personId === personId))
    setLocalHiddenAncestors(newHiddenAncestors)
    unhideAncestors(cisId, personIds).catch((error) => {
      setLocalHiddenAncestors(localHiddenAncestors)
      reportError(error)
    })
  }

  return {
    hiddenAncestors,
    hiddenAncestorsLoading,
    handleUnhideAncestors,
  }
}
